import React from "react";
import {
  modalCloseIcon,
  plusIcon,
} from "../../../utility-functions/assetLoader";
import classes from "./POCEmailContainer.module.css";
import { validateEmail } from "../../../utility-functions";
import Button from "../../design/Button";
import colors from "../../design/colors";

const POCEmailContainer = ({
  pocEmails,
  handleAddEmail,
  handleRemoveEmail,
  handleEmailChange,
}) => {
  return (
    <div className={classes.emailsContainer}>
      <label>
        POC emails <span>(optional)</span>
      </label>
      {pocEmails?.map((email, i) => {
        const isEmailValid = validateEmail(email);
        const showError = email !== "" && !isEmailValid;
        return (
          <div key={i} className={classes.emailContainer}>
            <div>
              <input
                value={email}
                id={i}
                onChange={(e) => handleEmailChange(e, i)}
                placeholder="Enter email"
                style={{
                  border: showError
                    ? `1.5px solid ${colors.cred_600}`
                    : `1px solid ${colors.cgrey_300}`,
                }}
              />
              <span onClick={() => handleRemoveEmail(i)}>
                {modalCloseIcon()}
              </span>
            </div>
            {showError && <p>Invalid email</p>}
          </div>
        );
      })}
      <Button
        styleOverride={{
          color: colors.cgreen_600,
          width: "132px",
          padding: "8px 12px",
          fontWeight: "500",
          height: "36px",
        }}
        buttonText={"Add email"}
        variant="outlined"
        hierarchy={"white"}
        icon={{
          startIcon: plusIcon(pocEmails?.length >= 5 ? colors.cgrey_300 : colors.cgreen_600),
          endIcon: null,
        }}
        onClick={handleAddEmail}
        disabled={pocEmails.length >= 5}
        tooltipMessage={
          pocEmails?.length >= 5 ? "Max 5 POC emails can be added " : ""
        }
      />
    </div>
  );
};

export default POCEmailContainer;
